;(function () {
  'use strict'

  angular
    .module('contrast.virtual-patch')
    .factory(
      'virtualPatchApiConfig',
      function virtualPatchApiConfigFactory($http, UserService) {
        'ngInject'

        return {
          getVirtualPatches: getVirtualPatches,
          getQuickFilters: getQuickFilters,
          getVirtualPatch: getVirtualPatch,
          deleteVirtualPatch: deleteVirtualPatch,
          toggleEnabled: toggleEnabled,
          addVirtualPatch: addVirtualPatch,
          editVirtualPatch: editVirtualPatch,
          prepopVirtualPatch: prepopVirtualPatch
        }

        function getVirtualPatches(filters) {
          return $http.get(UserService.buildAPIUrl('/patch'), {
            params: filters
          })
        }

        function getQuickFilters(filters) {
          return $http.get(UserService.buildAPIUrl('/patch/filters/quick'), {
            params: filters
          })
        }

        function getVirtualPatch(patchUuid) {
          return $http.get(UserService.buildAPIUrl('/patch/' + patchUuid))
        }

        function deleteVirtualPatch(patchUuid) {
          return $http['delete'](UserService.buildAPIUrl('/patch/' + patchUuid))
        }

        function toggleEnabled(patchUuid, environment) {
          return $http.post(
            UserService.buildAPIUrl(
              '/patch/' + patchUuid + '/enable/' + environment
            )
          )
        }

        function addVirtualPatch(form) {
          return $http.put(UserService.buildAPIUrl('/patch'), form)
        }

        function editVirtualPatch(patchUuid, form) {
          return $http.post(
            UserService.buildAPIUrl('/patch/' + patchUuid),
            form
          )
        }

        function prepopVirtualPatch(eventId) {
          return $http.get(UserService.buildAPIUrl('/patch/new/' + eventId))
        }
      }
    )
})()
